<template>
  <div class="top">
    <div class="header clearfix">
      <div class="logo fl">
        <img
          v-for="item in list"
          v-if="item.key == 100"
          :src="item.value"
          alt=""
        />
      </div>
      <div class="counts fl">
        <span class="text1">平台点击量:</span>
        <div class="countWrap">
          <ul class="totalCount">
            <li
              v-for="(item, index) in $commonJS.toThousands(Math.ceil(clicks))"
              :key="index"
              :class="item == ',' ? 'sign' : ''"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <span class="text1">次</span>
      </div>
      <!--<div class="fr date">-->
      <!--<span class="text">选择日期：</span>-->
      <!--<el-select v-model="value" placeholder="请选择" size="mini" value-key="value">-->
      <!--<el-option-->
      <!--v-for="item in options"-->
      <!--:key="item.value"-->
      <!--:label="item.label"-->
      <!--:value="item.value">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</div>-->
    </div>
    <!--县市-->
    <div class="districtNav" ref="nav">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide class="swiper-silde">
          <a
            href="javascript:;"
            class="btn-district"
            :class="{ active: !curDistrictId }"
            @click="select('')"
            >全市</a
          >
        </swiper-slide>
        <swiper-slide
          class="swiper-slide"
          v-for="(item, index) in districts"
          :key="index"
        >
          <a
            href="javascript:;"
            class="btn-district"
            :class="{ active: curDistrictId == item.districtId }"
            @click="select(item.districtId, item.districtName)"
            >{{ item.districtName }}</a
          >
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper"; //轮播插件
import "swiper/swiper-bundle.css";

export default {
  name: "Top",
  components: { Swiper, SwiperSlide },
  props: ["clicks"],
  data() {
    return {
      districts: "",
      curDistrictId: "",
      swiperOption: {
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        slidesPerView: "auto",
        spaceBetween: 30,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        observeParents: true,
      },
      value: "每日数据",
      options: [
        {
          value: "每日数据",
          label: "每日数据",
        },
        {
          value: "每周数据",
          label: "每周数据",
        },
        {
          value: "每月数据",
          label: "每月数据",
        },
        {
          value: "每年数据",
          label: "每年数据",
        },
      ],
      list: JSON.parse(localStorage.getItem("config")),
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.curDistrictId = !!sessionStorage.getItem("curDistrictId")
      ? sessionStorage.getItem("curDistrictId")
      : "";
    this.getDistricts();
  },
  methods: {
    getDistricts() {
      this.axios.post("api/BigData/Data/GetDistric").then((res) => {
        this.districts = res.data.appendData;
      });
    },
    select(id, name) {
      this.curDistrictId = id;
      sessionStorage.setItem("curDistrictId", id);
      if (!!id) {
        this.$router.push({ path: "/district", query: { id: id, name: name } });
      } else {
        this.$router.push({ path: "/home" });
      }
    },
  },
};
</script>

<style scoped lang="less">
.districtNav {
  /*width: 100%;*/
  overflow-x: hidden;
  background: #fff;
  margin-bottom: 20px;
  margin-top: 10px;
  .swiper-slide {
    width: auto;
    height: 62px;
    line-height: 62px;
  }
  .btn-district {
    /*width: calc(100% / 14);*/
    /*padding:10px 10px;*/
    /*margin: 0 12px;*/
    width: auto;
    font-size: 16px;
    color: #333333;
    text-align: center;
    display: inline-block;
    &.active {
      color: #1492ff;
    }
  }
}

.counts {
  text-align: center;
  color: #666666;
  margin-left: 50px;
  .text1 {
    display: inline-block;
    font-size: 12px;
    vertical-align: middle;
  }

  .countWrap {
    vertical-align: middle;
    display: inline-block;
  }

  .text2 {
    vertical-align: middle;
    display: inline-block;
    font-size: 28px;
  }

  .totalCount li {
    width: 25px;
    height: 25px;
    display: inline-block;
    color: #1492ff;
    font-size: 24px;
    text-align: center;
  }

  .totalCount li:not(.sign) {
    font-weight: bold;
    width: 25px;
    height: 25px;
    line-height: 25px;
    background: #fff;
    border: 1px solid #eeeeee;
    border-radius: 2px;
    margin: 0 3px;
  }
}

.date {
  .text {
    font-size: 16px;
    color: #666666;
  }
  /deep/ .el-select .el-input .el-select__caret {
    color: #9fcef9;
  }
  /deep/ .el-input__inner {
    width: 110px;
    border-color: #add5fa;
    border-radius: 30px;
    font-size: 14px;
    color: #1492ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue